import Controller from '@ember/controller';
import { computed, get, set, setProperties } from '@ember/object';
import { sort } from '@ember/object/computed';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  fundsService: service(),
  router: service(),
  store: service(),

  showValidationErrors: false,
  error: null,

  reset() {
    setProperties(this, {
      showValidationErrors: false,
      error: null,
    });
  },

  sortTntOrganizationsBy: Object.freeze(['name']),
  sortedTntOrganizations: sort(
    'model.tntOrganizations',
    'sortTntOrganizationsBy',
  ),
  tntOrganizationOptions: computed('sortedTntOrganizations.[]', function () {
    let options = [];
    this.sortedTntOrganizations.forEach((tntOrg) => {
      options.push({
        label: get(tntOrg, 'name'),
        val: get(tntOrg, 'id'),
      });
    });
    return options;
  }),

  selectedTntOrganization: computed(
    'model.changeset.tntOrganizationId',
    function () {
      let tntOrgId = get(this, 'model.changeset.tntOrganizationId');
      if (tntOrgId) {
        return get(this, 'model.tntOrganizations').find((x) => {
          return get(x, 'id') === tntOrgId;
        });
      } else {
        return null;
      }
    },
  ),

  save: task(function* () {
    set(this, 'error', null);
    let changeset = get(this, 'model.changeset');
    try {
      yield changeset.validate();
      set(this, 'showValidationErrors', true);
      if (get(changeset, 'isValid')) {
        // remove previously set username or password
        setProperties(changeset, {
          username: null,
          password: null,
        });
        yield this.fundsService.confirmValidFundToken();
        yield changeset.save();
        let tntOrg = this.selectedTntOrganization;
        if (get(tntOrg, 'oauthLogin')) {
          this.router.transitionTo(
            'funds.fund.more.donor-hub.connect.oauth-redirect',
          );
        } else {
          this.router.transitionTo(
            'funds.fund.more.donor-hub.connect.credentials',
          );
        }
      }
    } catch (error) {
      set(this, 'error', error);
    }
  }).drop(),
});
